<template>
  <div>
    <!-- https://codepen.io/hzbor/pen/pPwBGq -->
    <ul class="folder">
      <li>
        <div class="showhim">
          <span
            :key="
              pathOr(false, ['has_child'], folder)
                ? Object.keys(folderPlusclass)[0]
                : Object.keys(folderPlusclass)[0]
            "
            @click="toggle(folder)"
            @dblclick="toggleGetData(folder)"
          >
            <i
              class="fas fa-lg text-warning"
              :class="
                pathOr(false, ['has_child'], folder)
                  ? folderPlusclass
                  : folderclass
              "
          /></span>
          <b
            :title="`${$lang.parvandeh_count}:${
              folder && folder.parvandeh_count ? folder.parvandeh_count : `0`
            } `"
            @click="toggle(folder)"
            @dblclick="toggleGetData(folder)"
            class="text-tree"
            v-text="folder.name"
          />
          <div class="showme">
            <span
              v-for="(btn, i) in dynamicButton"
              :key="i"
              v-b-tooltip.hover
              :title="btn.tooltip"
              class="mx-2"
              @click="methodOnClick(folder, btn.type)"
            >
              <mdicon :name="btn.name" size="20" :class="btn.cls" />
            </span>
          </div>
        </div>
        <transition name="fade">
          <tree-folder-contents
            :children="folder.children"
            v-if="open"
            @methodOnClick="methodOnClick"
            @getData="getData"
            :dynamicButton="dynamicButton"
            @select="toggleGetData"
          >
          </tree-folder-contents>
        </transition>
      </li>
    </ul>
  </div>
</template>

<script>
import { pathOr } from "ramda";

export default {
  data() {
    return {
      open: false,
      classFolder: "fas fa-folder",
      showMenu: false,
      contextMenuWidth: null,
      contextMenuHeight: null,
    };
  },
  props: {
    folder: {
      type: [Object, Array],
    },
    dynamicButton: {
      type: [Object, Array],
    },
  },
  methods: {
    pathOr,
    openMenu() {
      this.showMenu = true;
    },
    toggle(item) {
      this.open = !this.open;
      if (pathOr(false, ["has_child"], item)) {
        this.$emit("getData", item);
      }
    },
    toggleGetData(item) {
      this.$emit("select", item);
    },
    methodOnClick(item, type) {
      this.$emit("methodOnClick", item, type);
    },
    getData(item) {
      this.$emit("getData", item);
    },
  },
  computed: {
    folderclass() {
      let foldclass = "fa-folder";
      switch (this.open) {
        case false:
          foldclass = "fa-folder";
          break;
        case true:
          foldclass = "fa-folder-open";
          break;
      }
      return {
        [foldclass]: true,
      };
    },
    folderPlusclass() {
      let foldclass = "fa-folder-plus";
      switch (this.open) {
        case false:
          foldclass = "fa-folder-plus";
          break;
        case true:
          foldclass = "fa-folder-open";
          break;
      }
      return {
        [foldclass]: true,
      };
    },
  },
};
</script>

<style>
.text-tree {
  cursor: pointer;
  padding: 0 5px;
}

.text-tree:hover {
  background-color: #9e9e9e;
  color: white !important;
  border-radius: 5px;
}
</style>
